export function Float32ToInt16SamplesConverter(input: Float32Array): ArrayBuffer {
    const buffer: ArrayBuffer = new ArrayBuffer(input.length*2);
    const output: DataView = new DataView(buffer);
    let offset: number = 0;

    for (let i: number = 0; i < input.length; i++, offset += 2) {
        let s: number = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
    }

    return output.buffer;
}